/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
// const BASE_URL = process.env.REACT_APP_API_URL;

const apiEndpoints = {
  auth: {
    login: 'user/login',
    adminAttendance: 'admin_attend_day_summary_list',
    resetEmployeeLoginPin: 'user/employee_reset_login_pin',
    resetEmployeeTransPin: 'user/employee_reset_transaction_pin',

    resetDriverLoginPin: 'user/driver_reset_login_pin',
    resetDriverTransPin: 'user/driver_reset_transaction_pin'
  },
  dashboard: {
    paymentDashboard: 'admin_dashboard',
    adminAttendance: 'admin_attend_day_summary_list',
    getFlyashTodayReport: 'challan/get_flyashchallan_today_report',
    getFlyashYesterdayReport: 'challan/get_flyashchallan_yesterday_report'
  },
  location: {
    getCounty: 'country/get_country',
    getState: id => `state/get_state?country_id=${id}`,
    getCity: id => `city/get_city?state_id=${id}`,
    create: 'location/create_location',
    get: 'get_all_location',
    getAll: 'location/get_all',
    update: id => `location/update_location/${id}`,
    getApprovalRequest: 'location/location_approvals/pending',
    getApprovalHistory: 'location/location_approval_history/approval',
    delete: `location/delete_detail`,
    getApprovalPendingList: 'location/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'location/get_approval_list', //getHistoryList
    getPendingDetail: id => `location_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'location_approval/approval_active',
    approvalInactive: 'location_approval/approval_inactive',
    approvedLocation: 'location_approval/approval_pending' //post
  },
  branch: {
    create: 'branch/create_branch',
    getAll: 'branch/get_all',
    update: id => `branch/update_branch/${id}`,
    getApprovalPendingList: 'branch/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'branch/get_approval_list', //getHistoryList
    approvalActive: 'branch_approval/approval_active',
    approvalInactive: 'branch_approval/approval_inactive',
    getPendingDetail: id => `branch_approval/get_approval_detail/${id}`, //popup data of pending
    approvedBranch: 'branch_approval/approval_pending', //post
    delete: `branch/delete_detail`
  },
  route: {
    create: 'route/create_route',
    getAll: 'route/get_all',
    update: id => `route/route_update/${id}`,
    getApprovalRequest: 'route/route_approvals/pending',
    // getApprovalRequest: 'route_approval_request',
    getApprovalHistory: 'route/route_approvals_history/approval',
    // getApprovalRequest: 'route_approval_request'
    // delete: id => `route/delete_detail/${id}`,
    delete: `route/delete_detail`,
    getApprovalPendingList: 'route/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'route/get_approval_list', //getHistoryList
    getPendingDetail: id => `route_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'route_approval/approval_active',
    approvalInactive: 'route_approval/approval_inactive',
    approvedRoute: 'route_approval/approval_pending' //post

    //  approvedRoute: '/route/route_approvals/pending'
  },
  driver: {
    tableList: 'driver_tablelist',
    // getAll: 'driver',
    // getById: id => `driver/${id}`,
    createProfile: 'driver/create_driver',
    updateProfile: id => `driver/update_driver/${id}`,

    createAddress: 'driver/create_driver_address_detail',
    createFinancial: 'driver/create_driver_bank_detail',
    updateFinancial: id => `driver/update_driver_bank_detail/${id}`,

    createIdentifications: 'driver/create_driver_document_detail',
    updateIdentifications: id => `driver/update_driver_document_detail/${id}`,
    createProfessional: 'driver/create_driver_professional_detail',
    updateProfessional: id => `driver/update_driver_professional_detail/${id}`,

    getApprovalRequest: 'vehical_approval_request',
    // getPendingDetail: id => `driver_approval/get_approval_detail/${id}`, //popup data of pending
    getById: id => `driver/get_detail/${id}`,
    getAll: 'driver/get_all',
    // approvalActive: 'driver_approval/approval_active',
    // approvalInactive: 'driver_approval/approval_inactive',
    // getUnAssignedDrivers: 'driver/get_all',
    // getAssignedDrivers: 'driver/get_all'
    getUnAssignedDrivers: id =>
      `vehicle_driver_relation/get_unassign_vehicle_driver?trucker_id=${id}`,
    getAssignedDrivers: id =>
      `vehicle_driver_relation/get_assign_vehicle_driver?trucker_id=${id}`,

    UnAssignedDrivers: 'vehicle_driver_relation/unassign_vehicle_driver',
    unAssignVehicleFromDriver: 'vehicle_driver_relation/unassign_vehicle',
    AssignedDrivers: 'vehicle_driver_relation/assign_vehicle_driver',
    changeAssignVehicleDriver:
      'vehicle_driver_relation/change_assign_vehicle_driver',
    changeUnassignVehicleDriver:
      'vehicle_driver_relation/change_unassign_vehicle_driver',
    createQuickDriver: 'driver/create_quick_driver',
    getDriverFromVehicle: id =>
      `challan/get_assign_driver_to_challan?trucker_id=${id}`,
    delete: id => `driver/delete_driver/${id}`,
    UpdateStatus: 'driver/update_driver_status',
    getApprovalPendingList: 'driver/driver_approval/driver_pending_list',
    getPendingDetail: id =>
      `driver/driver_approval/driver_pending_id_base/${id}`,
    approvedDriver: id => `driver/driver_approval/approval_pending/${id}`,
    approveUpdatedDriver: id =>
      `driver/driver_approval/approve_reject_update_request/${id}`,
    getApprovalHistoryList:
      'driver/driver_approval/driver_approval_rejected_list'
  },
  employee: {
    tableList: 'employee_tablelist',
    createProfile: 'employee/create_employee',
    updateProfile: id => `employee/update_employee/${id}`,
    createAddress: 'employee/create_employee_address_detail',
    createFinancial: 'employee/create_employee_bank_detail',
    updateFinancial: id => `employee/update_employee_bank_detail/${id}`,
    createIdentifications: 'employee/create_employee_document_detail',
    updateIdentifications: id =>
      `employee/update_employee_document_detail/${id}`,
    createProfessional: `employee/create_employee_professional_detail`,
    updateProfessional: id =>
      `employee/update_employee_professional_detail/${id}`,
    // createSalaryStructure: `employee/create_employee_saleryStructure_detail`,
    updateSalaryStructure: id =>
      `employee/update_employee_saleryStructure_detail/${id}`,
    // getApprovalRequest: 'employee_approval/approval_pending',
    getApprovalHistory: id => `employee_approval/approval_history/${id}`, //getApprovedHistory
    getById: id => `employee/get_detail/${id}`,
    getAll: 'employee/get_all',
    getApprovalPendingList: 'employee_approval/employee_pending_list', //getApprovalList
    // getApprovalHistoryList: 'employee/get_approval_list', //getHistoryList
    // getPendingDetail: id => `employee_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'employee_approval/approval_active',
    approvalInactive: 'employee_approval/approval_inactive',

    userSaleryCalculation: 'payroll/user_salary_calculation',
    createSaleryStructure: 'payroll/user_salary_store',
    getEmployeeManualPunch: 'punch/get_employee_manual_punch',
    manualPunchIn: 'punch/admin_hod_punch_in',
    manualPunchOut: 'punch/admin_hod_punch_out',
    delete: id => `employee/delete_detail/${id}`,
    UpdateStatus: 'employee/update_employee_status',
    ManualPunchCheckList: 'punch/manual-pending-list',
    manualPunchChecking: 'punch/manual-ar-process',
    getApprovalManualPendingList: 'punch/manual-approval-rejected-list', //getApprovalList
    getApprovalManualHistoryList: 'punch/manual-approved-list', //getHistoryList
    approvalAcceptOrReject: 'punch/update-manual-approval-rejected',

    LatePunchApprovalPendingList: 'punch/punch-pending-list',
    LatePunchApprovalHistoryList: 'punch/punch-approval-rejected-list',
    LatePunchApproval: 'punch/punch-approval',
    unBlockEmployee: 'employee/reset-login-status',
    getPendingDetail: id => `employee/employee_pending_id_base/${id}`,
    approvedEmployee: id => `employee_approval/approval_pending/${id}`,
    approveUpdatedEmployee: id =>
      `employee_approval/approve_reject_update_request/${id}`,
    getApprovalHistoryList: 'employee_approval/employee_approval_rejected_list',
    roleList: 'role/list'
  },
  department: {
    getAll: 'department/get_all',
    create: 'department/create_department',
    getDetail: id => `department/get_detail/${id}`,
    update: id => `department/update_department/${id}`,
    delete: `department/delete_detail`,
    getApprovalPendingList: 'department/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'department/get_approval_list', //getHistoryList
    getPendingDetail: id => `department_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'department_approval/approval_active',
    approvalInactive: 'department_approval/approval_inactive'
  },
  designation: {
    getAll: 'designation/get_all',
    create: 'designation/create_designation',
    getDetail: id => `designation/get_detail/${id}`,
    update: id => `designation/update_designation/${id}`,
    delete: `designation/delete_detail`,
    getApprovalPendingList: 'designation/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'designation/get_approval_list', //getHistoryList
    getPendingDetail: id => `designation_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'designation_approval/approval_active',
    approvalInactive: 'designation_approval/approval_inactive'
  },
  shift: {
    getAll: 'shift/get_all',
    create: 'shift/create_shift',
    update: id => `shift/update_shift/${id}`,
    delete: `shift/delete_detail`,
    getApprovalPendingList: 'shift/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'shift/get_approval_list', //getHistoryList
    getPendingDetail: id => `shift_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'shift_approval/approval_active',
    approvalInactive: 'shift_approval/approval_inactive'
  },
  holiday: {
    getAll: 'holiday/get_all',
    create: 'holiday/create_holiday',
    update: id => `holiday/update_holiday/${id}`,
    delete: `holiday/delete_detail`,
    getApprovalPendingList: 'holiday/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'holiday/get_approval_list', //getHistoryList
    getPendingDetail: id => `holiday_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'holiday_approval/approval_active',
    approvalInactive: 'holiday_approval/approval_inactive'
  },
  leave: {
    getAll: 'leave/get_all',
    create: 'leave/create_leave',
    update: id => `leave/update_leave/${id}`,
    delete: `leave/delete_detail`,
    getDetail: id => `leave/get_detail/${id}`,
    leaveAcceptRejeact: id => `leave/admin_leave_approve_or_decline/${id}`,
    getApprovalPendingList: 'leave/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'leave/get_approval_list', //getHistoryList
    getPendingDetail: id => `leave_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'leave_approval/approval_active',
    approvalInactive: 'leave_approval/approval_inactive',
    employeeleaveDetail: id =>
      `leave/get_employee_leave?employee_id=${id}&user_type=Employee`,
    employeeCurrentOnLeave: 'leave/get_employee_approved_leave',
    pendingLeaveRequest: 'leave/get_employee_pending_leave'
  },
  skillCategory: {
    getAll: 'category/get_all',
    create: 'category/create_category'
  },
  // skillCategory: {
  //   getAll: 'categories',
  //   create: 'category/create_category'
  // },
  // holiday: { getAll: 'holiday', create: 'holiday' },
  punch: {
    reset: 'punch/reset_punch',
    allowCasualBreak: 'punch/casual_punch'
  },
  attendance: {
    // create: 'attendance/create_attendance',
    adminAttendanceList: 'attendance/admin_attendance_list',
    adminAttendanceMonthList: 'attendance/admin_attendance_month_list',
    deshboardTodayAttendance: id =>
      `attendance/dashboard_today_attendance/${id}/Employee`,
    getAllUserAttendance: `attendance/get_all_user_attendance`,
    getSummaryOfEmployee: 'employee/admin_attendance_day_summary_list_employee',
    getTodayAttendanceEmployee: 'attendance/employee_today_attendance',
    getMonthlyAttendanceEmployee: month =>
      `attendance/employee_monthly_attendance?month_type=${month}`,
    getMonthlyAttendanceEmployeeCustom: (start_date, end_date) =>
      `attendance/employee_monthly_attendance_custome_date?start_date=${start_date}&end_date=${end_date}`,

    getSummaryOfDriver: 'attendance/driver_attendance_list',
    getTodayAttendanceDriver: 'attendance/driver_today_attendance',
    getMonthlyAttendanceDriver: month =>
      `attendance/driver_monthly_attendance?month_type=${month}`,

    getEmployeeAttendance: id => `attendance/get_employee_attendance/${id}`,
    getMonthlyDayWiseAttendance: 'attendance/get_month_daywise_attendance'
  },
  customer: {
    create: 'customer/create_customer',
    getAll: 'customer/get_all',
    getDetail: id => `customer/get_detail/${id}`,
    delete: `customer/delete_detail`,
    getApprovalPendingList: 'customer_approval/customer_pending_list', //getApprovalList
    getApprovalHistoryList: 'customer_approval/customer_approval_rejected_list', //getHistoryList
    getPendingDetail: id => `customer_approval/customer_pending_id_base/${id}`, //popup data of pending
    approvalActive: 'customer_approval/approval_active',
    approvalInactive: 'customer_approval/approval_inactive',
    // getApprovalRequest: 'customer/customer_approved_request'
    // approvedCustomer: 'customer/customer_approved'
    // getApprovalHistory: `customer/approval_history/${id}`,
    companyDetail: 'customer/create_customer',
    contactPersonDetail: 'contact_person/create_contact_person',
    approveCustomer: id => `customer_approval/approval_pending/${id}`, //approve
    approveUpdatedCustomer: id =>
      `customer_approval/approve_reject_update_request/${id}`
  },
  material: {
    create: 'material/create_material',
    getAll: 'material/get_all',
    getDetail: id => `material/get_detail/${id}`,
    update: id => `material/update_material/${id}`,
    delete: `material/delete_detail`,
    getApprovalPendingList: 'material/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'material/get_approval_list', //getHistoryList
    getPendingDetail: id => `material_approval/get_approval_detail/${id}` //popup data of pending
  },
  vehicle: {
    create: 'vehicle/create_vehicle',
    updateVehicle: id => `vehicle/update_vehicle/${id}`,
    // createKyc: 'vehicle/create_kyc',
    createKyc: 'kyc_detail/create_kyc',
    updateKycDetail: id => `kyc_detail/update_kyc/${id}`,

    getAll: 'vehicle/get_all',
    // getUnAssignedVehicles: 'vehicle/get_all',
    // getAssignedVehicles: 'vehicle/get_all',
    getUnAssignedVehicles: 'vehicle_driver_relation/get_unassign_vehicle',
    getAssignedVehicles: 'vehicle_driver_relation/get_assign_vehicle',

    getVehicleTrucker: id => `vehicle/get_vehicle_trucker?trucker_id=${id}`,

    getVehicleByTrucker: id =>
      `vehicle/get_vehicle_driver_trucker?trucker_id=${id}`,
    getDetail: id => `vehicle/get_detail/${id}`,
    // update: id => `vehicle/update_vehicle/${id}`,
    delete: `vehicle/delete_detail`,
    getApprovalPendingList: 'vehicle_approval/vehicle_pending_list', //getApprovalList
    getApprovalHistoryList: 'vehicle_approval/vehicle_approval_rejected_list', //getHistoryList
    getPendingDetail: id => `vehicle_approval/vehicle_pending_id_base/${id}`, //popup data of pending
    approvalActive: 'vehicle_approval/approval_active',
    approvalInactive: 'vehicle_approval/approval_inactive',
    // assignDriver: 'vehicle_driver_relation/assign_vehicle_driver',
    // unAssignDriver: 'vehicle_driver_relation/unassign_vehicle_driver'
    createQuickVehicle: 'vehicle/create_quick_vehicle',
    approveVehicle: id => `vehicle_approval/approval_pending/${id}`,
    approveUpdatedVehicle: id =>
      `vehicle_approval/approve_reject_update_request/${id}`
  },
  po: {
    create: 'purchase_order/create_purchase_order',
    getAll: 'purchase_order/get_all',
    getDetail: id => `purchase_order/get_detail/${id}`,
    update: id => `purchase_order/update_purchase_order/${id}`,
    delete: `purchase_order/delete_detail`,

    getApprovalHistory: `purchase_order_approval/purchase_order_approval_rejected_list`, //getApprovedHistory
    getApprovalPendingList:
      'purchase_order_approval/purchase_order_pending_list', //getApprovalList
    getApprovalHistoryList: 'po/get_approval_list', //getHistoryList
    getPendingDetail: id =>
      `purchase_order_approval/purchase_order_pending_id_base/${id}`, //popup data of pending
    approvalActive: 'po_approval/approval_active',
    approvalInactive: 'po_approval/approval_inactive',
    approvedPo: id => `purchase_order_approval/approval_pending/${id}`,
    approvedUpdatedPo: id =>
      `purchase_order_approval/approve_reject_update_request/${id}`
  },
  do: {
    create: 'delivery_order/create_delivery_order',
    getAll: 'delivery_order/get_all',
    getDetail: id => `delivery_order/get_detail/${id}`,
    update: id => `delivery_order/update_delivery_order/${id}`,
    delete: `delivery_order/delete_detail`,
    getApprovalHistoryData: id =>
      `delivery_order_approval/approval_history/${id}`,
    getApprovalPendingList:
      'delivery_order_approval/delivery_order_pending_list', //getApprovalList
    getApprovalHistory:
      'delivery_order_approval/delivery_order_approval_rejected_list', //getHistoryList
    getPendingDetail: id =>
      `delivery_order_approval/delivery_order_pending_id_base/${id}`, //popup data of pending
    approvalActive: 'do_approval/approval_active',
    approvalInactive: 'do_approval/approval_inactive',
    approvedDo: id => `delivery_order_approval/approval_pending/${id}`,
    approvedUpdatedDo: id =>
      `delivery_order_approval/approve_reject_update_request/${id}`
  },
  permit: {
    create: 'permit/create_permit',
    getAll: 'permit/get_all',
    getDetail: id => `permit/get_detail/${id}`,
    update: id => `permit/update_permit/${id}`,
    delete: `permit/delete_detail`,
    getApprovalPendingList: 'permit_approval/permit_pending_list', //getApprovalList
    getApprovalHistoryList: 'permit_approval/permit_approval_rejected_list', //getHistoryList
    getPendingDetail: id => `permit_approval/permit_pending_id_base/${id}`, //popup data of pending
    approvalActive: 'permit_approval/approval_active',
    approvalInactive: 'permit_approval/approval_inactive',
    approvedPermit: id => `permit_approval/approval_pending/${id}`,
    approvedUpdatedPermit: id =>
      `permit_approval/approve_reject_update_request/${id}`
  },
  vehicleType: {
    create: 'vehicle_type/create_vehicle_type',
    getAll: 'vehicle_type/get_all',
    getDetail: id => `vehicle/get_detail/${id}`,
    update: id => `vehicle_type/update_vehicle_type/${id}`,
    delete: `vehicle_type/delete_detail`,
    getApprovalPendingList: 'vehicleType/get_pending_list', //getApprovalList
    getApprovalHistoryList: 'vehicleType/get_approval_list', //getHistoryList
    getPendingDetail: id => `vehicleType_approval/get_approval_detail/${id}`, //popup data of pending
    approvalActive: 'vehicleType_approval/approval_active',
    approvalInactive: 'vehicleType_approval/approval_inactive'
  },
  trucker: {
    getAll: 'trucker/get_all',
    getDiscounterList: 'trucker/get_trucker_list_by_type/discounter',
    createTrucker: 'trucker/create_trucker',
    updateTrucker: id => `trucker/update_trucker/${id}`,
    createContactPerson: 'trucker_contact_person/create',
    updateContactPerson: id => `trucker_contact_person/update/${id}`,

    createTaxInformation: 'trucker_tax_information/create',
    updateTaxInformation: id => `trucker_tax_information/update/${id}`,

    createBankDetail: 'trucker_bank_detail/create',
    updateBankDetail: id => `trucker_bank_detail/update/${id}`,

    getDetail: id => `trucker/get_detail/${id}`,
    getAssignedTruckers: 'trucker/get_all',

    getTruckerDriverList: id => `trucker/driver_by_trucker/${id}`,
    getTruckerVehicleList: id => `trucker/vehicle_by_trucker/${id}`,
    // getTruckerVehicleList: id => `trucker/vehicle_by_trucker/${id}`
    createQuickTrucker: 'trucker/create_quick_trucker',
    getTruckerPaymentPending: id =>
      `trucker_payment/get_trucker_payment_pending/${id}`,

    getTruckerPaymentPaid: id =>
      `trucker_payment/get_trucker_payment_paid/${id}`,
    EditQuickTrucker: 'trucker/quick_trucker_update',
    getApprovalPendingList: 'trucker/get_trucker_approval_all_pending_list', //getApprovalList
    getApprovalHistoryList: 'trucker/get_trucker_all_approval_list', //getHistoryList
    getPendingDetail: id => `trucker/get_trucker_approval_list_by_id/${id}`, //popup data of pending
    approveAndRejectTruck: 'trucker/quick_trucker_approval_and_reject',
    truckerInformation: id => `trucker/trucker_information/${id}`,
    createPaymentSettlement: 'trucker/store_settlement_data',
    getSettlementDetail: id => `trucker/get_settlement_detail/${id}`,
    getAllSettlementList: 'trucker/get_all_settlement_detail',
    getSettlementDetailById: id =>
      `trucker/get_all_settlement_detail_trucker_id/${id}`,
    getSettlementDataById: id => `trucker/get_settlement_detail/${id}`,
    updateSettlementStatus: 'trucker/update_settlement_status'
  },
  truckerPayment: {
    TruckerPaymentHistory: id =>
      `trucker/get_all_settlement_history_detail_trucker_id/${id}`,
    TruckerPaymentPendingDetail: 'trucker/get_trucker_pending_details_data',
    truckerPaymentPendingList: 'trucker_payment/get_trucker_payment_pending',
    detailPagePendingList: (id, type) => {
      console.log('🚀 ~ type:', type);
      return `trucker/trucker_payment_information/${id}/${type}`;
    },
    truckerPaymentPay: 'trucker/settlement_amount_transaction',
    truckerRetrievePayment: 'trucker/retrieve_settlement_payment'
  },
  challan: {
    // getAll: 'trucker/get_all',
    createChallan: 'challan/create_challan',
    updateChallan: id => `challan/update_challan/${id}`,
    getChallanDetail: id => `challan/get_challan/${id}`,
    getChallanDashboard: 'challan_payment/get_payment_dashboard',
    // getApprovalPendingList: 'challan/get_challan_pending',
    getApprovalPendingList: 'challan_payment/get_payment_pending',
    getApprovalHistoryList: 'challan_approval/approval_history',
    getPendingDetail: id => `challan_approval/get_pending_detail/${id}`, //popup data of pending

    approvalActive: 'challan_approval/approval_active',
    approvalInactive: 'challan_approval/approval_inactive',
    getChallanPrint: id => `challan/get_challan_print/${id}`,
    approvedChallan: 'challan_approval/approval_pending', //post
    // approvedLocation: 'location_approval/approval_pending' //post
    getPaymentInitiated: 'challan_payment/get_payment_initiated',
    getPaymentCancelled: 'challan_payment/get_payment_cancelled',
    challanPayment: 'challan_payment/create_payment',
    cancelChallan: 'challan/cancel_challan',
    assignDriverToChallan: 'challan/assign_driver_to_challan',
    getPaymentPendingFlyash: 'challan_payment/get_payment_pending_flyash',
    getPaymentInitiatedFlyash: 'challan_payment/get_payment_initiated_flyash',
    getPaymentCancelledFlyash: 'challan_payment/get_payment_cancelled_flyash',
    // receivePod: 'challan/receive_pod_by_challan_no',
    receivePod: 'challan/receive_pod_by_challan_id',

    getChallanApprovalList: 'challan/get_pod_pending_list',
    // getChallanApprovalList: 'challan/get_challan_pod_approval_list',
    getPodApprovalList: 'challan/get_pod_approved_list', /// on this api 12/03/25

    checkAndRejectChallan: 'challan/approve_and_reject_pod_by_challan_no',

    ApproveAndRejectChallan: 'challan/approve_and_reject_pod_by_challan_no',

    getReceivePodByChallan: challan_no =>
      `challan/get_pod_list_by_pod_id/${challan_no}`,
    // getReceivePodByChallan: challan_no =>
    //   `challan/get_receive_pod_by_challan_no/${challan_no}`,
    fetchFlyashChallan: challan_no =>
      `challan/fetch-flyash-challan?challan_no=${challan_no}`,
    getCoalIronoreReport: 'challan/get_coal_iron_orechallan_report',
    retrievePayment: 'challan_payment/retrieve_payment',
    payViaCash: 'challan_payment/pay_via_cash_payment',
    getDetail: id => `challan/get_challan_details/${id}`,
    checkChallan: 'challan/check_and_reject_pod_by_challan_no'
  },
  regular: {
    getAll: 'regular/get_all',
    createRegularVendor: 'regular/create_regular',
    updateRegularVendor: id => `regular/update_regular/${id}`,
    createContactPerson: 'regular_contact_person/create',
    updateContactPerson: id => `regular_contact_person/update/${id}`,
    createTaxInformation: 'regular_tax_information/create',
    updateTaxInformation: id => `regular_tax_information/update/${id}`,
    createBankDetail: 'regular_bank_detail/create',
    updateBankDetail: id => `regular_bank_detail/update/${id}`,
    getDetail: id => `regular/get_detail/${id}`
  },
  fuel: {
    getAll: 'fuel_retailer/get_all',
    createFuelVendor: 'fuel_retailer/create_fuel_retailer',
    updateFuelVendor: id => `fuel_retailer/update_fuel_retailer/${id}`,
    createContactPerson: 'fuel_retailer_contact_person/create',
    updateContactPerson: id => `fuel_retailer_contact_person/update/${id}`,
    createTaxInformation: 'fuel_retailer_tax_information/create',
    updateTaxInformation: id => `fuel_retailer_tax_information/update/${id}`,
    createBankDetail: 'fuel_retailer_bank_detail/create',
    updateBankDetail: id => `fuel_retailer_bank_detail/update/${id}`,
    getDetail: id => `fuel_retailer/get_detail/${id}`
  },

  trips: {
    getRunningTrips: 'trip/get_running_trip',
    getCompleteTrip: 'trip/get_ended_trip',
    getBreakdownTrip: 'trip/get_breakdown_trip',
    restartBreakdown: 'trip/process_restart_trip'
  },
  QuickPayment: {
    creteQuickPayment: 'quick_payment/create_quick_pay',
    getQuickPay: id => `quick_payment/get_quick_pay?vehicle_number=${id}`,
    getQuickPayList: 'quick_payment/get_quick_pay_list',
    paymentHistory: 'challan_payment/get_payment_history'
  },
  payroll: {
    monthPayableSalery: 'payroll/month_payable_salary',
    checkViewSalary: 'payroll/checkviewsalaryapi',
    RunPayroll: id =>
      `payroll/salary_month_list_data?payroll_id=${id}&user_type=Employee`,
    RunPayrollData: id =>
      `payroll/total_salary_month_data?payroll_id=${id}&user_type=Employee`,
    userSaleryDetail: (id, payrollId) =>
      `payroll/user_salary_details?payroll_id=${payrollId}&user_type=Employee&user_id=${id}`
  },
  invoice: {
    createInvoice: 'vendor_invoice/create_invoice',
    getAll: 'vendor_invoice/get_all',
    getCheckInvoice: 'vendor_invoice/get_check_invoice',
    approveInvoice: id => `vendor_invoice/approve/${id}`,
    rejectInvoice: id => `vendor_invoice/reject/${id}`
  },
  setting: {
    getApprovalPendingList: 'comman_approval/comman_pending_list', //getApprovalList
    getApprovalHistoryList: 'comman_approval/comman_approval_rejected_list', //getHistoryList
    getPendingDetail: id => `comman_approval/comman_pending_id_base/${id}`, //popup data of pending,
    approvedSettingDetail: id => `comman_approval/approval_pending/${id}`,
    approvedUpdatedSetting: id =>
      `comman_approval/approve_reject_update_request/${id}`
  },
  rolesPermission: {
    roles: 'role/list',
    createRole: 'role/create',
    updateRole: id => `role/update/${id}`,
    updatePermission: 'role/update-permissions',
    getPermission: id => `role/details/${id}`
  },
  commonApproval: {
    getApprovalPendingList: id =>
      `multiple_comman_approval/multiple_comman_pending_list?model_name=${id}&`,
    getApprovalHistoryList: id =>
      `multiple_comman_approval/multiple_comman_approval_rejected_list?model_name=${id}&`,
    getPendingDetail: id =>
      `multiple_comman_approval/multiple_comman_pending_id_base/${id}`,
    approvedDetail: id => `multiple_comman_approval/approval_pending/${id}`,
    approvedUpdatedDetail: id =>
      `multiple_comman_approval/approve_reject_update_request/${id}`
  }
};
export default apiEndpoints;
